import { useState } from "react";
import SteelcaseRefinementList from "./SteelcaseRefinementList";
import Portal from "../Portal/Portal";
import { FiltersStruct } from "./Filters";

// interface Filters { 
//     filterName: string
//     filterAttr: string
//     limit?: number
//     searchable?: boolean
//     sort?: string[]
//     pinnedItems?: string[] | undefined
//     placeholderText?: string
//     order: number | undefined;
// }

interface FilterModalProps {
    isOpen: boolean;
    handleClose: () => void
    filters: FiltersStruct[]
    isMobile: boolean;
}

export default function FilterModal({ isOpen, handleClose, filters, isMobile }: FilterModalProps) {
    
    const [count, setCount] = useState(0);
    const [selectedItemsCount, setSelectedItemsCount] = useState(0);
    const [attrCount, setAttrCount] = useState<{ [key: string]: number}>({});

    const handleApplyAllFilters = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setCount((prevCount) => prevCount + 1);
    }

    const handleSelectedItemsCount = (filterAttr: string, filterCount: number) => {
        setAttrCount((prevAttrs) => {
            const newAttrs = { ...prevAttrs };
            newAttrs[filterAttr] = filterCount
            return newAttrs;
        });
        let count = 0;
        Object.entries(attrCount).forEach(item => {
            count += item[1]
        })
        setSelectedItemsCount(count)   
    }

    return (
        <Portal wrapperId="fl-filter-modal">
            <div className={"fl-container__mb-modal"} style={!isOpen ? {display: "none"} : {}}>
                <div className={"finish-filters-mobile-modal__container"}>
                    <div className={"finish-filters-mobile-modal__header"}>
                        <h1>{window.steelcase_i18n["steelcase-finish-library"].filters_title || "Filters"}</h1>
                        <button className={"finish-filters-mobile-modal__close"} onClick={handleClose}>X</button>
                    </div>

                    <section className={`finish-filters-modal__filter-section`}>
                        {
                            filters.map((filter, idx) => {
                                return (
                                    <div className={`finish-filters-modal__filter-section-content`} key={idx}>
                                        <h3 className={`finish-filters-modal__filter-section-header`}>{filter.filterName}</h3>
                                        <div className={`${!filter.nested && "finish-filters-modal__filter-section-grid"}`}>
                                            {
                                                !filter.nested ?
                                                    <SteelcaseRefinementList 
                                                        key={`${filter.filterName}-mobile`} 
                                                        filterName={filter.filterName} 
                                                        filterAttr={filter.filterAttr} 
                                                        count={count} 
                                                        showHeading={false}
                                                        searchable={filter.searchable} 
                                                        limit={filter.limit}
                                                        sort={filter.sort}
                                                        pinnedItems={filter.pinnedItems}
                                                        sortItems={filter.sortItems}
                                                        sortItemCriteria={filter.sortItemCriteria}
                                                        placeholderText={filter.placeholderText} 
                                                        setApplyCount={handleSelectedItemsCount} 
                                                        isMobile={isMobile} 
                                                    />
                                                :
                                                filter.nestedAttrs && 
                                                    filter.nestedAttrs.map((nestedFilter) => {
                                                        return (
                                                            <div key={`${filter.filterName}-${nestedFilter.filterName}`}>
                                                                <p className={"finish-filters-modal__nested-filter"}>{nestedFilter.filterName} <i className={"finish-filters-modal__nested-filter-icon"}>&#9432;</i></p>
                                                                <div className={"finish-filters-modal__filter-section-grid"}>
                                                                    <SteelcaseRefinementList
                                                                        key={`${filter.filterName}-${nestedFilter.filterName}`} 
                                                                        filterName={`${filter.filterName}-${nestedFilter.filterName}`} 
                                                                        filterAttr={nestedFilter.filterAttr} 
                                                                        count={count} 
                                                                        showHeading={false}
                                                                        searchable={filter.searchable} 
                                                                        limit={nestedFilter.limit}
                                                                        sort={filter.sort}
                                                                        pinnedItems={nestedFilter.pinnedItems}
                                                                        sortItems={nestedFilter.sortItems}
                                                                        sortItemCriteria={nestedFilter.sortItemCriteria}
                                                                        placeholderText={filter.placeholderText} 
                                                                        setApplyCount={handleSelectedItemsCount} 
                                                                        isMobile={isMobile} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                            }
                                            
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                    </section>

                    <div className={"finish-filters--flex finish-filters-modal__filter-section-footer"}>
                        <button
                            className={"finish-filters__button finish-filters__button--primary"}
                            onClick={(event) => {
                                handleApplyAllFilters(event)
                                handleClose();
                            }}
                        >
                            {window.steelcase_i18n['steelcase-finish-library'].filters.apply || "Apply"} { selectedItemsCount && selectedItemsCount > 0 ? `${selectedItemsCount}+ ${window.steelcase_i18n["steelcase-finish-library"].materials || "MATERIALS"}` : ""}
                        </button>
                    </div>
                </div>
                
            </div>
        </Portal>
    )
}